import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `../views/${view}.vue`);
}

function loadAdminView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/Admin/${view}.vue`
    );
}

function loadUserView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/User/${view}.vue`
    );
}

function loadReferralView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/ReferenceLead/${view}.vue`
    );
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: loadView("Home"),
    },
    {
      path: "/profile",
      name: "profile",
      component: loadUserView("profile"),
    },
    {
      path: "/product-master",
      name: "productmaster",
      component: loadAdminView("product-master"),
    },
    {
      path: "/discount-master",
      name: "discountmaster",
      component: loadAdminView("discount-master"),
    },
    {
      path: "/customer-search",
      name: "customersearch",
      component: loadAdminView("customer-search"),
    },
    {
      path: "/customer-subs",
      name: "customersubs",
      component: loadAdminView("customer-subs"),
    },
    {
      path: "/customer-payments",
      name: "customerpayments",
      component: loadAdminView("customer-payments"),
    },
    {
      path: "/customer-invoice",
      name: "customerinvoice",
      component: loadAdminView("customer-invoice"),
    },
    {
      path: "/associate-master",
      name: "associatemaster",
      component: loadAdminView("associate-master"),
    },
    {
      path: "/referral",
      name: "referral",
      component: loadAdminView("referral"),
    },
    {
      path: "/leads",
      name: "leads",
      component: loadAdminView("leads"),
    },
    {
      path: "/join",
      name: "joinlead",
      component: loadReferralView("joinlead"),
    },
    {
      path: "/join/:id",
      name: "joinlead",
      component: loadReferralView("joinlead"),
    },
    {
      path: "/loginpage",
      name: "leadloginpage",
      component: loadReferralView("leadloginpage"),
    },
    {
      path: "/buy-product/:redirectCode?",
      name: "buy-product",
      component: loadUserView("buy-product"),
    },
    {
      path: "/subscriptions",
      name: "subscriptions",
      component: loadUserView("subscriptions"),
    },
    // {
    //     path: "/data-subscriptions",
    //     name: "datasubscriptions",
    //     component: loadUserView("data-subscriptions"),
    // },
    {
      path: "/payment-history",
      name: "payment-history",
      component: loadUserView("payment-history"),
    },
    {
      path: "/payu-response",
      name: "payu-response",
      component: loadUserView("payu-response"),
    },
    {
      path: "/fail-payu-response",
      name: "payu-response-fail",
      component: loadUserView("payu-response-fail"),
    },
    {
      path: "/invalidurl",
      name: "invalidurllead",
      component: loadReferralView("invalidurllead"),
    },
    {
      path: "/logout-sso/:basecode?",
      name: "logout-sso",
      component: loadUserView("logout-sso"),
    },
  ],
});
